import { handleApiError } from 'utils/api';
import { env } from '../../../../constants';
import {
  DEGREES_API_URL,
  STUDIES_API_URL,
  UNIVERSITIES_API_URL
} from './constants';
import {
  DegreesResponse,
  StudiesResponse,
  UniversitiesResponse
} from './types';

const DEFAULT_PAGE_SIZE = 100;
const acceptedLanguages = ['DE', 'EN'];

export const fetchUniversitiesPage = async (
  page: number
): Promise<UniversitiesResponse | undefined> => {
  const response = await fetch(
    `${env.VITE_API_BASE_URL}/${UNIVERSITIES_API_URL}?page=${page}&size=${DEFAULT_PAGE_SIZE}`,
    {
      method: 'GET'
    }
  );

  if (!response.ok) {
    await handleApiError(response);
  }

  return response.json() as Promise<UniversitiesResponse | undefined>;
};

export const fetchStudiesPage = async (
  page: number,
  language: (typeof acceptedLanguages)[number]
): Promise<StudiesResponse | undefined> => {
  const response = await fetch(
    `${env.VITE_API_BASE_URL}/${STUDIES_API_URL}?page=${page}&size=${DEFAULT_PAGE_SIZE}`,
    {
      method: 'GET',
      headers: {
        'Accept-Language': language
      }
    }
  );

  if (!response.ok) {
    await handleApiError(response);
  }

  return response.json() as Promise<StudiesResponse | undefined>;
};

export const fetchDegreesPage = async (
  page: number,
  language: (typeof acceptedLanguages)[number]
): Promise<DegreesResponse | undefined> => {
  const response = await fetch(
    `${env.VITE_API_BASE_URL}/${DEGREES_API_URL}?page=${page}&size=${DEFAULT_PAGE_SIZE}`,
    {
      method: 'GET',
      headers: {
        'Accept-Language': language
      }
    }
  );

  if (!response.ok) {
    await handleApiError(response);
  }

  return response.json() as Promise<DegreesResponse | undefined>;
};
